import React, { FC, memo } from 'react';

interface Props {
  onClick: () => void;
  label: string;
  icon: string;
}

const MenuButton: FC<Props> = ({ label, icon, onClick }) => {
  return (
    <button onClick={onClick} type='button' className='btn btn-sm btn-outline-success'>
      <span className={`icon ${icon}`}>{label}</span>
    </button>
  );
};

export default memo(MenuButton);
